import type { AssignmentTypeCondition as AssignmentTypeConditionType } from "@redotech/redo-flows-common/rules/schemas";
import { AssignmentTypeOption } from "@redotech/redo-flows-common/rules/schemas";
import { useTranslation } from "@redotech/redo-i18n";
import { RedoListItem } from "@redotech/redo-web/arbiter-components/list/redo-list";
import { RedoSingleSelectDropdownInput } from "@redotech/redo-web/arbiter-components/select-dropdown/redo-single-select-dropdown-input";
import { Flex } from "@redotech/redo-web/flex";
import { memo } from "react";

export const AssignmentTypeCondition = memo(function AssignmentTypeCondition({
  condition,
  onChange,
  editableFields,
}: {
  condition: AssignmentTypeConditionType;
  onChange: (updated: AssignmentTypeConditionType) => void;
  /**
   * When omitted, all fields are editable (normal authoring). When
   * provided, only fields whose name is in the set are editable.
   */
  editableFields?: ReadonlySet<string>;
}) {
  const { t } = useTranslation();
  const assignmentTypeEditable =
    editableFields === undefined || editableFields.has("assignmentType");

  const assignmentOptions: RedoListItem<AssignmentTypeOption>[] = [
    {
      id: AssignmentTypeOption.AI_AGENT_ASSIGNEE,
      type: "text",
      text: AssignmentTypeOption.AI_AGENT_ASSIGNEE,
      value: AssignmentTypeOption.AI_AGENT_ASSIGNEE,
    },
    {
      id: AssignmentTypeOption.SUPPORT_AGENT_ASSIGNEE,
      type: "text",
      text: AssignmentTypeOption.SUPPORT_AGENT_ASSIGNEE,
      value: AssignmentTypeOption.SUPPORT_AGENT_ASSIGNEE,
    },
    {
      id: AssignmentTypeOption.NO_ASSIGNEE,
      type: "text",
      text: AssignmentTypeOption.NO_ASSIGNEE,
      value: AssignmentTypeOption.NO_ASSIGNEE,
    },
  ];

  const selectedAssignment = assignmentOptions.find(
    (option) => option.id === condition.assignmentType,
  );

  return (
    <Flex dir="column" gap="md" w="full">
      <RedoSingleSelectDropdownInput<AssignmentTypeOption>
        disabled={!assignmentTypeEditable}
        fitToAnchor
        label={t("Assignment")}
        options={assignmentOptions}
        optionSelected={({ item }) => {
          if (!assignmentTypeEditable) {
            return;
          }
          onChange({ ...condition, assignmentType: item.value });
        }}
        selectedItem={selectedAssignment}
      />
    </Flex>
  );
});
